/* eslint-disable no-console */
import Cookies from 'js-cookie';

const getPartner = () => {
  const defaultPartner = {
    partnerId: 1,
    partnerKey: 'Carvana',
    partnerLongName: 'Carvana',
    partnerVanityUrlName: 'notused',
    partnerWhisperNumber: '1.800.333.4554',
    isExtendedWarrantyOffered: true
  };

  const partnerJson = Cookies.getJSON('PartnerObject');
  if (!partnerJson) {
    return defaultPartner;
  }
  return partnerJson;
};

export default getPartner;
